import { ArrowUpRight } from 'lucide-react';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { useTranslation } from '../../../../lib/i18n';
import { SYMPHONY_COMMUNITY_URL } from '../shared';
import { CommunityIcon } from '../components/icons';
import { RailTooltip } from './RailTooltip';
import styles from './RailCommunity.module.css';

// "Join our community" above the account row (Figma `Sidebar-Menu` 22535:282645): the group glyph, the
// label and a trailing ↗, since the row leaves the app. Collapsed it is the glyph, named by its tooltip.
// Same URL, `rel` and BI as CommunityLink, which the old rail and the mobile drawer render.
export function RailCommunity({ collapsed = false }: { collapsed?: boolean }) {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  const label = t('sidebar.community.join');
  const common = {
    href: SYMPHONY_COMMUNITY_URL,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: () => logPageClickBi({ page_name: 'menu', button_name: 'join_community', origin: 'menu' }),
  } as const;

  if (collapsed) {
    return (
      <RailTooltip label={label}>
        <a {...common} aria-label={label} className={`orion-nav-item ${styles.iconItem}`}>
          <CommunityIcon size={18} />
        </a>
      </RailTooltip>
    );
  }
  return (
    <a {...common} className={`orion-nav-item ${styles.row}`}>
      <span aria-hidden className={styles.icon}>
        <CommunityIcon size={18} />
      </span>
      <span className={styles.label}>{label}</span>
      <span aria-hidden className={`${styles.arrow} dir-flip`}>
        <ArrowUpRight size={16} aria-hidden />
      </span>
    </a>
  );
}
